import { Button } from '@mui/material';
import React from 'react';

const CustomButton = ({
  text,
  color,
  bgcolor,
  onClick,
  width,
  img,
  border,
  type,
  disabled = false,
}) => {
  const showBefore = img && text !== 'Custom' && text !== 'Approve';
  const showAfter = img && (text === 'Custom' || text === 'Approve');

  // Determine if `img` is a string (URL) or a component (icon)
  const renderImg = () => {
    if (typeof img === 'string') {
      return <img src={img} alt="" />;
    }
    return <>{img}</>;
  };

  return (
    <Button
      sx={{
        color: color,
        bgcolor: bgcolor,
        borderRadius: '7px',
        minWidth: width,
        textTransform: 'none',
        border: `1px solid ${border}`,
        height: { xs: '40px', md: '30px' },
        fontSize: { xs: '12px', md: '14px' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        p: 2,
        transition: 'filter 0.15s ease-in-out',
        '&:hover': {
          backgroundColor: bgcolor,
          filter: 'brightness(90%)',
        },
      }}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {showBefore && renderImg()}
      {text}
      {showAfter && renderImg()}
    </Button>
  );
};

export default CustomButton;
